import { LitElement, html, css, CSSResultGroup, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import buttonStyles from "../styles/button.css?inline";

export type ApidaeButtonVariant = "secondary100";

@customElement("apidae-button")
export class ApidaeButton extends LitElement {
  static styles: CSSResultGroup = [
    css`
      :host {
        display: inline-block;
      }

      :host([fullwidth]) {
        display: block;
      }
    `,
    unsafeCSS(buttonStyles),
  ];

  /**
   * Variante visuelle du bouton
   */
  @property({ type: String })
  variant: ApidaeButtonVariant = "secondary100";

  /**
   * Désactive le bouton
   */
  @property({ type: Boolean, reflect: true })
  disabled: boolean = false;

  /**
   * Si vrai, le bouton prend toute la largeur disponible
   */
  @property({ type: Boolean, reflect: true })
  fullwidth: boolean = false;

  private get buttonClass() {
    const classes = ["apidae-button"];

    classes.push(`apidae-button--${this.variant}`);

    if (this.fullwidth) {
      classes.push("apidae-button--fullwidth");
    }

    return classes.join(" ");
  }

  render() {
    return html`
      <button class=${this.buttonClass} ?disabled=${this.disabled}>
        <span class="apidae-button__label">
          <slot></slot>
        </span>
        <span class="apidae-button__icon">
          <slot name="icon"></slot>
        </span>
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "apidae-button": ApidaeButton;
  }
}
